import { render } from "./ProformaList.vue?vue&type=template&id=2bd4f0c2&scoped=true"
import script from "./ProformaList.vue?vue&type=script&lang=js"
export * from "./ProformaList.vue?vue&type=script&lang=js"

import "./ProformaList.vue?vue&type=style&index=0&id=2bd4f0c2&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd4f0c2"]])

export default __exports__